module.exports = __webpack_public_path__ + "static/img/ip_girl@2x.f89aca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FPS/ip_girl@2x.png
// module id = b0Ao
// module chunks = 1